<template>
  <section class="Fiche__cartouche Fiche__cartouche__a4 text-moyen">
    <div class="block">
      <p>
        <span class="text-light">Programme</span>&nbsp;<span class="text-reg">{{
          p.program_description | mo
        }}</span>

        <span v-if="getEntrBySlug('maitre-douvrage', p.interlocuteurs_d)">
          <span class="text-light"> Maître&nbsp;d'ouvrage</span>&nbsp;<span
            class="text-reg"
            >{{
              getDistinctArrBySlug("maitre-douvrage", p.interlocuteurs_d)
                .map(a => unbreakable(a.partner.name))
                .join(" ")
            }}</span
          ></span
        >

        <span>
          <span class="text-light"> Procédure</span>&nbsp;<span
            class="text-reg"
            >{{ mapNames(p.procedures) | mo }}</span
          >
        </span>

        <span class="text-light" v-if="architectes">
          Équipe&nbsp;de&nbsp;maîtrise&nbsp;d'œuvre</span
        >&nbsp;<span class="text-reg"
          ><span v-for="(a, index) in architectes" :key="index"
            >{{ filterScalene(a) | u
            }}<span v-if="index !== architectes.length - 1">, </span></span
          ></span
        >

        <span v-if="drop.indexOf('missions') === -1 && p.missions.length > 0"
          ><span class="text-light"> {{ "Mission" | plural(p.missions) }}</span
          >&nbsp;<span class="text-reg">{{ mapNames(p.missions) }}</span>
        </span>

        <span v-if="p.normes.length"
          ><span class="text-light"> Normes</span>&nbsp;<span
            class="text-reg"
            >{{ mapNames(p.normes) }}</span
          ></span
        >
        <span v-if="p.awards.length"
          ><span class="text-light"> Récompenses</span>&nbsp;<span
            class="text-reg"
          >
            {{ mapNames(p.awards) }}</span
          ></span
        >
        <span v-if="p.labels.length">
          <span class="text-light"> Labels</span>&nbsp;<span class="text-reg">{{
            mapNames(p.labels)
          }}</span></span
        >
        <span v-if="p.cost"
          ><span class="text-light"> Coût</span>&nbsp;<span class="text-reg"
            >{{ formatNumbersFrench(p.cost) }}€</span
          ></span
        >
        <span v-if="p.surface"
          ><span class="text-light"> Surface</span>&nbsp;<span class="text-reg"
            >{{ formatNumbersFrench(p.surface) }}m<sup>2</sup></span
          ></span
        >
        <span v-if="p.surface"
          ><span class="text-light"> Typologies</span>&nbsp;<span
            class="text-reg"
            >{{ mapNames(p.typologies) }}</span
          ></span
        >
        <span
          v-if="p.contents_d.filter(a => a.axe_id && a.axe_id !== 1).length"
        >
          <span class="text-light"> Intentions&nbsp;</span
          ><span class="text-reg">{{
            mapNames(p.contents_d.filter(a => a.axe_id !== 1))
          }}</span></span
        >
      </p>
    </div>
    <div class="block">
      <p>
        <span class="text-reg" v-html="$root.$options.filters.mo(text)"></span>
      </p>
    </div>
  </section>
</template>
<script>
import {
  getEntrBySlug,
  getEntrNamesBySlugMatching,
  mapNames,
  filterScalene,
  formatNumbersFrench,
  getDistinctArrBySlug,
  unbreakable,
  getArchitectesWithMandataireDistinction
} from "../../../../../util/func";

export default {
  name: "CartoucheFiche",
  props: {
    p: {},
    pm: {},
    drop: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      bottomText: ""
    };
  },
  methods: {
    getEntrBySlug,
    getEntrNamesBySlugMatching,
    mapNames,
    filterScalene,
    formatNumbersFrench,
    getDistinctArrBySlug,
    unbreakable
  },
  computed: {
    architectes() {
      return getArchitectesWithMandataireDistinction(this.p);
    },
    text() {
      const a = this.p.contents_d.find(a => a.axe_id === this.pm.axe);
      return a ? (a.text ? a.text : "") : "";
    }
  }
};
</script>
